import { useState } from 'react';
import SchedulesTab from './SchedulesTab';
import MessageTemplatesTab from './MessageTemplatesTab';
import CatalogTemplatesTab from './CatalogTemplatesTab';
import PartnersTab from './PartnersTab';
import ScheduleRunLogsTab from './ScheduleRunLogsTab';
import MessageLogsTab from './MessageLogsTab';
import MessagingQualityTab from './MessagingQualityTab';
import MessagingHealthWidget from './MessagingHealthWidget';

interface Props {
    token: string;
}

type SubTab = 'schedules' | 'templates' | 'catalog' | 'partners' | 'logs' | 'messageLogs' | 'quality';

const TABS: { key: SubTab; label: string }[] = [
    { key: 'schedules', label: 'Schedules' },
    { key: 'templates', label: 'Message Templates' },
    { key: 'catalog', label: 'Template Catalog' },
    { key: 'partners', label: 'Partners & Approach' },
    { key: 'logs', label: 'Run Logs' },
    { key: 'messageLogs', label: 'Message Logs' },
    { key: 'quality', label: 'Messaging Quality' },
];

export default function MessagingTab({ token }: Props) {
    const [activeSubTab, setActiveSubTab] = useState<SubTab>('schedules');

    return (
        <div>
            <div className="mb-6 flex items-start justify-between gap-4 flex-wrap">
                <div>
                    <h2 className="text-xl font-semibold text-gray-900">Messaging Controls</h2>
                    <p className="text-sm text-gray-500">Manage providers, templates, pricing and automated schedules.</p>
                </div>
                <MessagingHealthWidget token={token} onOpenDetails={() => setActiveSubTab('quality')} />
            </div>

            <div className="border-b border-gray-200 mb-6">
                <nav className="-mb-px flex space-x-8" aria-label="Tabs">
                    {TABS.map(t => (
                        <button
                            key={t.key}
                            onClick={() => setActiveSubTab(t.key)}
                            className={`${activeSubTab === t.key
                                ? 'border-indigo-500 text-indigo-600'
                                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                } whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm`}
                        >
                            {t.label}
                        </button>
                    ))}
                </nav>
            </div>

            {activeSubTab === 'schedules' && <SchedulesTab token={token} />}
            {activeSubTab === 'templates' && <MessageTemplatesTab token={token} />}
            {activeSubTab === 'catalog' && <CatalogTemplatesTab token={token} />}
            {activeSubTab === 'partners' && <PartnersTab token={token} />}
            {activeSubTab === 'logs' && <ScheduleRunLogsTab token={token} />}
            {activeSubTab === 'messageLogs' && <MessageLogsTab token={token} />}
            {activeSubTab === 'quality' && <MessagingQualityTab token={token} />}
        </div>
    );
}
